import script from "./Sign-in.vue?vue&type=script&setup=true&lang=js"
export * from "./Sign-in.vue?vue&type=script&setup=true&lang=js"

import "./Sign-in.vue?vue&type=style&index=0&id=8be98652&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8be98652"]])

export default __exports__